import Srcset from "@/components/common/Srcset";
import { generalConstants } from "@/utils/constants";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const ActivateAccount = (props) => {
  const { styles, setShowResetPassword, accountSidebarOpen, setSignInTab } = props;
  const isPWA = useSelector((state) => state.pwa.is_PWA);

  useEffect(() => {
    if(window.innerWidth > 768) {

      !accountSidebarOpen && setShowResetPassword();
    }
  }, [accountSidebarOpen]);

  return (
    <div className={`${styles.activate_account}`}>
      <a
        onClick={() => {
          setShowResetPassword(false);
        }}
        className={!isPWA?"forgot_auth_back":"pwa_forgot_auth_back"}
      >
        <Srcset
          requirePath={true}
          svgFile={true}
          src="images/Icons/Arrow/Right/large.svg"
          alt="back-button"
          height="14.31"
          width="24"
          className="right_arrow"
          tabIndex={0}
        />
      </a>

      <p className="large light">Activate your account</p>
      <p
        className={`small-xs small-sm normal-md ${styles.activate_account_text}`}
      >
        {`
            Nearly there. Please check your email to finish activating your account.
          `}
      </p>
      <div>
        <p
          className={`text-center small-xs small-sm normal-md ${styles.mailto}`}
        >
          Need assistance? Contact us by{" "}
          <a tabIndex={0} href={`mailto:${generalConstants.help_email} ga-help`}>email</a>
        </p>
      </div>
    </div>
  );
};

export default ActivateAccount;
